import { render, staticRenderFns } from "./DeckStack.vue?vue&type=template&id=005b963d"
import script from "./DeckStack.vue?vue&type=script&lang=js"
export * from "./DeckStack.vue?vue&type=script&lang=js"
import style0 from "./DeckStack.vue?vue&type=style&index=0&id=005b963d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports